module.exports = __webpack_public_path__ + "goat.png?e5a346c9e58d819f4a6e72f93b5c3270";